export const amplifyLogs = {
  taskStatus: {
    type: 'LIPTaskSection',
    action: 'SortStatusColumnClicked',
    description: 'Task Section Status Column'
  },
  name: {
    type: 'LIPTaskSection',
    action: 'SortNameColumnClicked',
    description: 'Task Section Name Column'
  },
  filterByDropdown: {
    type: 'LIPTaskSectionFilterBy',
    action: 'DropdownClicked',
    description: 'Task Section Filter By'
  },
  filterByToDoDropdown: {
    type: 'LIPTaskSectionFilterBy',
    action: 'ToDoClicked',
    description: 'Task Section Filter By To Do'
  },
  uploadedDoc: {
    type: 'LIPDocUploadTask',
    action: 'UploadedDocCaretClicked',
    description: 'Task Section Doc Upload Task '
  },
  filterByInReviewDropdown: {
    type: 'LIPTaskSectionFilterBy',
    action: 'InReviewClicked',
    description: 'Task Section Filter By In Review'
  },
  filterByCompletedDropdown: {
    type: 'LIPTaskSectionFilterBy',
    action: 'CompletedClicked',
    description: 'Task Section Filter By Completed'
  },
  filterByAllTasksDropdown: {
    type: 'LIPTaskSectionFilterBy',
    action: 'AllTasksClicked',
    description: 'Task Section Filter By All Tasks'
  }
};
//# sourceMappingURL=amplifyLogs.js.map